// extracted by mini-css-extract-plugin
export default {"orbiowaycontainer":"strip_orbiowaycontainer__glQsh"};